import { render, staticRenderFns } from "./materialbyso.vue?vue&type=template&id=4a4b64d4&scoped=true&"
import script from "./materialbyso.vue?vue&type=script&lang=js&"
export * from "./materialbyso.vue?vue&type=script&lang=js&"
import style0 from "./materialbyso.vue?vue&type=style&index=0&id=4a4b64d4&lang=scss&scoped=true&"
import style1 from "./materialbyso.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b64d4",
  null
  
)

export default component.exports